// src/i18n/translations/de.js
const translations = {
  brand: "Marke",
  category: "Kategorie",
  type: "Typ",
  cargo_capacity: "Laderaum",
  seats: "Sitze",
  created_at: "Erstellt am",
  updated_at: "Aktualisiert am",
  id: "ID",
  user_id: "Benutzer-ID",
  invoices: "Rechnungen",
  vehicle: "Meine Fahrzeuge",
  transfer_new: "Neue Fahrten",
  transfer_assign: "Fahrer zuweisen",
  vatIdLabel: "USt-IdNr. des Kunden",
  bookingAs: "Ich buche als",
  privatePerson: "Privatperson",
  companyOption: "Firma",
  companyName: "Firmenname",
  vatIdOptional: "USt-IdNr. (optional)",
  vatIdInvalid: "Ungültige USt-IdNr. (z. B. DE123456789)",
  receiptHint: "Für die Quittung/Rechnung",
  transfer_close: "Zum Abschließen",
  completeTrip: "Abschließen",
  completeTripConfirm: "Fahrt abschließen? Der Kunde erhält die Dankes-Mail und die Quittung, die Zahlung wird als bezahlt markiert.",
  instantConfirmed: "Sofort bestätigt",
  ratingFilter: "Bewertung",
  allRatings: "Alle Bewertungen",
  starsAndUp: "Sterne und mehr",
  instantHint: "Sofort bestätigt: Ihre Buchung wird direkt bestätigt",
  transfer_all_admin: "Alle Fahrten im Überblick",
  transfer_new_admin: "Neue Fahrten",
  transfer_today_admin: "Heutige Fahrten",
  transfer_tomorrow_admin: "Fahrten Morgen",
  transfer_current_admin: "Laufende Fahrten",
  transfer_storno_admin: "Stornierte Fahrten",
  transfer_reklamiert_admin: "Reklamierte Fahrten",
  transfer_noshow_admin: "NoShow Fahrten",
  transfer_finished_admin: "Abgeschlossene Fahrten",
  first_name: "Vorname",
  last_name: "Nachname",
  pickup_datetime: "Abholdatum / Abholzeit",
  status: "Status",
  total_price: "Gesamtpreis",
  route: "Von → Nach",
  payment_method: "Zahlungsmethode",
  currency: "Währung",
  invoice_status: "Rechnung",
  data: "Mein Unternehmen",
  company_active: "Benutzer Freigeschaltet",
  logo: "Unternehmen Logo Upload",
  company_name: "Firmenname",
  company_legal_form: "Unternehmensform",
  company_register_number: "Handelsregisternummer",
  company_street: "Anschrift",
  company_zip: "Plz.",
  company_country: "Land",
  company_city: "Stadt",
  company_tax_number: "Steuer-ID.",
  company_vat_id: "Ustd. Nr.",
  company_phone: "Rufnummer (Geschäftlich)",
  company_email: "E-Mail Adresse (Geschäftlich)",
  company_website: "Webseite/Homepage",
  licence: "Gewerbeschein Upload",
  company_licence: "Gewerbeschein Vorhanden?",
  company_licence_expiration: "Gewerbeschein Ablaufdatum?",
  prices: "Gestaffelte Preise",
  bis10km: "Berechneter Kilometer Preis bis 10KM",
  bis20km: "Berechneter Kilometer Preis bis 20KM",
  bis50km: "Berechneter Kilometer Preis bis 50KM",
  bis100km: "Berechneter Kilometer Preis bis 100KM",
  ab100km: "Berechneter Kilometer Preis ab 100KM",
  citys: "Angefahrene Städte",
  getpartner: "Partner werden",
  partnerlogin: "Partner login",
  editbooking: "Buchung verwalten",
  contact: "Kontakt",
  booknow: "Jetzt buchen",
  oneway: "Nur Hinfahrt",
  roundtrip: "Hin- & Rückfahrt",
  flughafentransfer: "Flughafentransfer",
  ConvenientAndOnTime: "Pünktlich. Komfortabel.",
  yourTransfer: "Dein Transfer.",
  bnHeadline: "Wohin darf es heute gehen?",
  bnSub: "Dein Flughafentransfer zum Festpreis – in wenigen Klicks gebucht",
  bnPopular: "Beliebte Strecken",
  bnRoute1: "Köln → Flughafen Düsseldorf",
  bnRoute2: "Essen → Flughafen Düsseldorf",
  bnRoute3: "Düsseldorf → Flughafen Köln/Bonn",
  bnRoute4: "Bonn → Flughafen Frankfurt",
  moBestRated: "Beste Bewertung",
  moRecommended: "Empfohlen",
  moAll: "Alle",
  moDetails: "Details",
  moLess: "Weniger",
  moOffersN: "{n} Angebote",
  moOfferOne: "1 Angebot",
  moFrom: "ab",
  moPicksTitle: "Unsere Auswahl für dich",
  moCheapest: "Günstigste",
  guideHello: "Hallo, wohin geht's?",
  guideTitle1: "Dein Transfer",
  guideTitle2: "in 3 Schritten",
  guideStepRoute: "Route",
  guideStepDate: "Termin",
  guideStepOffer: "Angebot",
  guideRoute: "Deine Strecke",
  guideWhen: "Wann?",
  guideToday: "Heute",
  guideTomorrow: "Morgen",
  guidePick: "Datum",
  guidePickupTime: "Abholzeit",
  guideReturn: "Rückfahrt dazubuchen",
  uberHeadline: "Dein Transfer – überall hin",
  privateTransferDescription: "Privater Fahrservice zu Festpreisen – von Tür zu Tür, ohne Überraschungen.",
  bookRide:"Fahrt buchen",
  destination: "Ziel",
  enterDestinationAddress: "Zieladresse",
  returnTrip: "Rückfahrt",
  outboundTrip: "Hinfahrt",
  paymentMethods: "Zahlungsmethoden",
  showOffers: "Angebote anzeigen",
  rides: "Fahrten",
  customerRating: "Kundenbewertung",
  vehicles: "Fahrzeuge",
  support: "Support",
  recentSearches: "Letzte Suchen",
  departure: "Abfahrt",
  enterStartAddress: "Startadresse",
  swapAddresses: "Adressen tauschen",
  whyGoTransfer24: "Warum GoTransfer24",
  clearBenefits: "Klare Vorteile",
  atAGlance: "auf einen Blick.",
  fairFixedPricesTitle: "Faire Festpreise",
  fairFixedPricesDescription: "Kein Taxameter, kein Risiko. Der Preis steht vor der Buchung fest – transparent und garantiert.",
  bookedIn60SecondsTitle: "In 60 Sekunden gebucht",
  bookedIn60SecondsDescription: "Start, Ziel, Fahrzeug – fertig. Keine Registrierung, kein Papierkram, keine Wartezeit.",
  flexiblePaymentTitle: "Flexibel zahlen",
  flexiblePaymentDescription: "PayPal, Kreditkarte oder Bar beim Fahrer. Du entscheidest, was dir am besten passt.",
  verifiedDriversTitle: "Geprüfte Fahrer",
  verifiedDriversDescription: "Alle Fahrer sind lizenziert und persönlich verifiziert. Pünktlichkeit und Professionalität garantiert.",
  available247Title: "24/7 verfügbar",
  available247Description: "Frühflug um 4 Uhr? Kein Problem. Wir sind rund um die Uhr für dich da.",
  luggageExtrasTitle: "Gepäck & Extras",
  luggageExtrasDescription: "Kindersitz, Vielgepäck, Haustier – alles buchbar. Einfach beim Checkout hinzufügen.",
  chooseRoute: "Strecke wählen",
  selectTripType: "Hin- oder Hin- und Rückfahrt auswählen",
  enterAddresses: "Start- und Zieladresse eingeben",
  setDateTime: "Datum & Uhrzeit festlegen",
  chooseVehicle: "Fahrzeug auswählen",
  compareOffersPrices: "Angebote und Preise vergleichen",
  selectVehicle: "Passendes Fahrzeug auswählen",
  enterDetails: "Details angeben",
  enterPassengerDetails: "Fahrgastdaten eintragen",
  addFlightInformation: "Fluginformationen ergänzen",
  selectExtras: "Extras & Zusatzleistungen wählen",
  confirmation: "Bestätigung",
  selectPaymentMethod: "Zahlungsart auswählen",
  receiveBookingConfirmation: "Buchungsbestätigung erhalten",
  businessAirportTransfer: "Business Flughafen Transfer",
  economyAirportTransfer: "Economy Flughafen Transfer",
  luxuryAirportTransfer: "Luxury Flughafen Transfer",
  vipSprinterTransfer: "VIP Sprinter Transfer",
  faqPriceQuestion: "Was kostet ein Flughafentransfer bei GoTransfer24?",
  faqPriceAnswer: "Der Preis hängt von Strecke, Datum und gewählter Fahrzeugklasse ab und wird dir vor Abschluss der Buchung als Festpreis angezeigt. Zusatzkosten für Stau, Nachtfahrt oder normales Gepäck fallen nicht an.",
  faqAdvanceBookingQuestion: "Wie weit im Voraus sollte ich buchen?",
  faqAdvanceBookingAnswer: "Eine Buchung ist auch kurzfristig möglich, wir empfehlen jedoch mindestens 24 Stunden im Voraus – besonders bei hoher Nachfrage an Feiertagen oder in der Hauptreisezeit.",
  faqFlightDelayQuestion: "Was passiert, wenn mein Flug Verspätung hat?",
  faqFlightDelayAnswer: "Kein Problem – die Ankunftszeit wird live nachverfolgt und automatisch angepasst. Dein Fahrer weiß über die Verspätung Bescheid und wartet entsprechend, ohne dass zusätzliche Kosten entstehen.",
  faqCancelChangeQuestion: "Kann ich meine Buchung stornieren oder ändern?",
  faqCancelChangeAnswer: "Ja, Änderungen und Stornierungen sind bis zu 24 Stunden vor der geplanten Abholung kostenlos möglich.",
  faqChildSeatsQuestion: "Bietet ihr Kindersitze und barrierefreie Fahrzeuge an?",
  faqChildSeatsAnswer: "Ja, Kindersitze verschiedener Gruppen lassen sich bei der Buchung hinzufügen, und unsere Van-Klasse ist an vielen Standorten auch rollstuhlgerecht buchbar.",
  faqPaymentQuestion: "Welche Zahlungsmethoden werden akzeptiert?",
  faqPaymentAnswer: "Online kannst du mit Karte, PayPal, Klarna, auf Rechnung oder per Ratenzahlung bezahlen. Vor Ort ist die Zahlung direkt beim Fahrer ebenfalls möglich.",
  transferServiceDescription: "GoTransfer24 vermittelt geprüfte Fahrer für private Flughafentransfers in ganz Deutschland und Europa. Ob Geschäftsreise, Familienurlaub oder Städtetrip – wir bringen dich zuverlässig und ohne Umwege zum Flughafen oder direkt zur Haustür zurück. Festpreise, automatische Flugüberwachung bei Verspätungen und eine Buchung in unter einer Minute machen den Transfer so unkompliziert wie möglich.",
  routePriceCologneDusseldorf: "ab 99 €",
  routePriceFrankfurtHeidelberg: "ab 129 €",
  routePriceMunichAugsburg: "ab 89 €",
  routePriceHamburgLuebeck: "ab 79 €",
  routePriceBerlinPotsdam: "ab 69 €",
  routePriceStuttgartUlm: "ab 109 €",
  popularRoutes: "Beliebte Strecken",
  allLocations: "Alle Standorte",
  chooseYour: "Wählen Sie Ihren",
  airport_: "Flughafen.",
  allLocationsOverview: "Alle Standorte im Überblick",
  locationsDescription: "GoTransfer24 vermittelt geprüfte Partner-Fahrer an 26 Standorten in 11 Ländern. Jede Stadt hat eine eigene Seite mit lokalen Strecken, Terminal-Infos und Fragen speziell zu diesem Flughafen.",
  priceDisclaimer: "* Preis, Dauer und Entfernung sind ungefähre Angaben und stellen kein verbindliches Angebot dar.",
  somethingWentWrong: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  sustainability: "Nachhaltigkeit",
  everyRide: "Jede Fahrt",
  aTree: "ein Baum.",
  treePlantingDescription: "Für jede Online- und WhatsApp-Buchung pflanzen wir einen Baum. Als umweltbewusstes Unternehmen möchten wir nicht nur nachhaltige Mobilität fördern, sondern auch aktiv zum Umweltschutz beitragen. Danke für deine Unterstützung.",
  treesPlanted: "Bäume gepflanzt",
  compensated: "Kompensiert",
  howItWorks: "So funktioniert's",
  inFourSteps: "In 4 Schritten",
  toBooking: "zur Buchung.",
  ourStrengths: "Unsere Stärken",
  clearAdvantagesWith: "Klare Vorteile mit",
  freeNonBindingService: "Kostenloser, unverbindlicher Service",
  punctualPickupsGuaranteed: "Pünktliche Abholungen garantiert",
  verifiedDriverNetwork: "Geprüftes Fahrernetzwerk",
  upTo70PercentCheaperThanTaxis: "Bis zu 70 % günstiger als Taxis",
  topRatingsSatisfiedCustomers: "Top-Bewertungen zufriedener Kunden",
  customerReviews: "Kundenstimmen",
  whatOurCustomers: "Was unsere Kunden",
  say: "sagen.",
  reviewMarco: "Super pünktlich, sauberes Fahrzeug und ein freundlicher Fahrer. Buche ich immer wieder.",
  reviewLena: "Einfach zu buchen und viel günstiger als ein Taxi. Perfekt für den Flughafen!",
  reviewThomas: "Professioneller Service vom ersten Klick bis zur Ankunft. Sehr empfehlenswert.",
  supportDescription: "Bei Fragen, Anregungen oder Kommentaren steht Ihnen unser qualifiziertes Support-Team gerne zur Verfügung.",
  germany: "Deutschland",
  netherlands: "Niederlande",
  belgium: "Belgien",
  france: "Frankreich",
  luxembourg: "Luxemburg",
  switzerland: "Schweiz",
  austria: "Österreich",
  czechia: "Tschechien",
  poland: "Polen",
  denmark: "Dänemark",
  turkey: "Türkei",
  cologne: "Köln",
  dusseldorf: "Düsseldorf",
  frankfurt: "Frankfurt",
  munich: "München",
  berlin: "Berlin",
  hamburg: "Hamburg",
  stuttgart: "Stuttgart",
  hannover: "Hannover",
  amsterdam: "Amsterdam",
  eindhoven: "Eindhoven",
  brussels: "Brüssel",
  charleroi: "Charleroi",
  paris: "Paris",
  luxembourgCity: "Luxemburg",
  zurich: "Zürich",
  geneva: "Genf",
  basel: "Basel",
  vienna: "Wien",
  prague: "Prag",
  warsaw: "Warschau",
  copenhagen: "Kopenhagen",
  istanbul: "Istanbul",
  antalya: "Antalya",
  bodrum: "Bodrum",
  izmir: "Izmir",
  ankara: "Ankara",
  priceCologneDusseldorf: "ab 99 €",
  priceFrankfurtHeidelberg: "ab 79 €",
  priceMunichAugsburg: "ab 149 €",
  priceHamburgLuebeck: "ab 149 €",
  allQuestions: "Alle Fragen",
  viewAnswers: "Antworten ansehen",
  frequentlyAskedQuestions: "Häufige Fragen",
  questionsAbout: "Fragen zum",
  airportTransfer: "Flughafentransfer",
  travelKnowledge: "Reisewissen",
  guide: "Ratgeber",
  our: "Unser",
  tipsInsightsNewsDescription: "Tipps, Insights und Neuigkeiten rund um Flughafentransfers, Reisen und Mobilität.",
  viewAllGuideArticles: "Alle Ratgeber-Artikel ansehen",
  haveAQuestion: "Haben Sie eine Frage?",
  travelTips: "Reisetipps",
  business: "Business",
  family: "Familie",
  stressFreeAirportTransferTitle: "Die 7 besten Tipps für einen stressfreien Flughafentransfer",
  stressFreeAirportTransferDescription: "So planst du deine Anreise zum Flughafen so entspannt wie möglich – von der richtigen Pufferzeit bis zur passenden Fahrzeugklasse.",
  businessTravelTitle: "Business Travel: So kommst du entspannt zum wichtigen Meeting",
  businessTravelDescription: "Zwischen Flug und Termin bleibt oft wenig Zeit. Wir zeigen, wie du mit der richtigen Planung pünktlich und ausgeruht ankommst.",
  familyVacationTitle: "Familienurlaub: Mit Kindern sicher zum Flughafen",
  familyVacationDescription: "Kindersitze, Gepäck und müde Kids – wir geben praktische Tipps, wie die Anreise zum Flughafen für die ganze Familie entspannt bleibt.",
  june12_2026: "12. Juni 2026",
  may28_2026: "28. Mai 2026",
  may15_2026: "15. Mai 2026",
  readTime4Minutes: "4 Min. Lesezeit",
  readTime3Minutes: "3 Min. Lesezeit",
  readTime5Minutes: "5 Min. Lesezeit",
  roundTripShort: "Hin & Rück",
  editSearch: "Suche bearbeiten",
  edit: "Bearbeiten",
  startNewSearch: "Neue Suche starten",
  search: "Suchen",
  dateRequired: "Datum erforderlich",
  timeRequired: "Uhrzeit erforderlich",
  returnDateRequired: "Rückfahrtdatum erforderlich",
  returnTimeRequired: "Rückfahrtuhrzeit erforderlich",
  vehicleCategory: "Fahrzeugkategorie",
  categoryTaxi: "Taxi",
  categoryEconomy: "Economy",
  categoryBusiness: "Business",
  categoryMinibus: "Minibus",
  categoryMinibusWheelchair: "Minibus Rollstuhl",
  categoryGoGreen: "GoGreen",
  categoryFirstClass: "First Class",
  categoryKomfort: "Komfort",
  categoryLuxury: "Luxury",
  filterTitle: "Filter",
  passengers: "Fahrgäste",
  vehiclesForAtLeast: "Fahrzeuge für ≥",
  people: "Personen",
  luggage: "Gepäck",
  luggagePieces: "Gepäckstücke",
  wheelchair: "Rollstuhl",
  allVehicles: "Alle Fahrzeuge",
  wheelchairSeats: "Rollstuhlplätze",
  noRatingsYet: "Noch keine Bewertungen",
  orSimilar: "oder ähnlich",
  upTo: "bis zu",
  handLuggage: "Handgepäck",
  childSeatGroup1Name: "Kindersitzgruppe 1",
  childSeatGroup1Desc: "(Ca. ab 1 Jahr bis 4 Jahre), 9 bis 18 kg",
  childSeatGroup23Name: "Kindersitzgruppe 2/3",
  childSeatGroup23Desc: "(Ca. ab 5 Jahre bis 12 Jahre), 18 bis 38 kg",
  babySeatName: "Babyschale",
  babySeatDesc: "Bis 12 Monate altes Baby. +1 kg – 9 kg",
  luggageHelpName: "Gepäckhilfe",
  luggageHelpDesc: "Der Fahrer leistet Hilfe für das Gepäck",
  meetGreetName: "Meet & Greet",
  meetGreetDesc: "Der Fahrer empfängt Sie mit einem Namensschild und hilft beim Gepäck.",
  privateRide: "Private Fahrt",
  support247: "24/7 Support",
  freeCancellation: "Kostenfrei stornierbar bis 24h vor Fahrt",
  provider: "Anbieter",
  bookNow: "Jetzt buchen",
  showLess: "Weniger anzeigen",
  moreOffers: "weitere Angebote",
  priceFrom: "Preis ab",
  book: "Buchen",
  loadingOffers: "Angebote werden geladen …",
  noOfferIdFound: "Keine Angebots-ID gefunden",
  errorLoadingOffers: "Fehler beim Laden der Angebote",
  unknownError: "Unbekannter Fehler",
  offersFound: "Angebote gefunden",
  cheapest: "↑ Günstigste",
  mostExpensive: "↓ Teuerste",
  noVehiclesFound: "Keine Fahrzeuge für die gewählten Filter gefunden.",
  resetFilters: "Filter zurücksetzen",
  taxi_limousine: "Taxi Limousine",
  taxi_kombi: "Taxi Kombi",
  taxi_van: "Taxi Van",
  economy_limousine: "Economy Limousine",
  economy_kombi: "Economy Kombi",
  economy_minivan: "Economy Minivan",
  economy_van: "Economy Van",
  business_kombi: "Business Kombi",
  business_van: "Business Van",
  minibus: "Minibus",
  business_limousine: "Business Limousine",
  minibus_wheelchair: "Minibus Rollstuhl",
  gogreen: "GoGreen",
  firstclass: "First Class",
  komfort: "Komfort",
  luxury: "Luxury",
  oclock: "Uhr",
  vehicleSection: "Fahrzeug",
  max: "Max",
  included: "Inklusive",
  freeCancelShort: "Kostenlos stornieren",
  serviceProviderLabel: "Dienstleister",
  routeSection: "Route",
  priceOverview: "Preisübersicht",
  ride: "Fahrt",
  loadingData: "Wird geladen …",
  noSessionIdFound: "Keine Session-ID gefunden",
  dataLoadError: "Daten konnten nicht geladen werden.",
  less: "weniger",
  more: "mehr",
  free: "Kostenlos",
  next: "Weiter",
  errorSavingExtras: "Fehler beim Speichern der Zusatzleistungen.",
  extraServicesTitle: "Zusatzleistungen",
  transferDetails: "Transfer Details",
  closeDetails: "Details schließen",
  showDetails: "Details anzeigen",
  closeShort: "↓ Schließen",
  detailsShort: "↑ Details",
  totalPrice: "Gesamtpreis",
  childSeatGroup1: "Kindersitzgruppe 1",
  childSeatGroup1Description: "(Ca. ab 1 Jahr bis 4 Jahre), 9 bis 18 kg",
  childSeatGroup2_3: "Kindersitzgruppe 2/3",
  childSeatGroup2_3Description: "(Ca. ab 5 Jahre bis 12 Jahre), 18 bis 38 kg",
  infantCarrier: "Babyschale",
  infantCarrierDescription: "Bis 12 Monate altes Baby. +1 kg – 9 kg",
  waterSnack: "Wasser & Snack",
  waterSnackDescription: "Eine Flasche Wasser und ein kleiner Snack warten im Fahrzeug auf Sie.",
  petTransport: "Haustier-Mitnahme",
  petTransportDescription: "Ihr Haustier fährt mit. Bitte Transportbox oder Leine bereithalten.",
  welcomeFlowers: "Blumen / Willkommenspaket",
  welcomeFlowersDescription: "Ein Blumenstrauß oder Willkommenspaket für Ihre Gäste im Fahrzeug – ideal für Hotel und Hochzeit.",
  powerBank: "Powerbank / Ladekabel",
  powerBankDescription: "Ladekabel und Powerbank im Fahrzeug, damit Ihr Handy sicher ankommt.",
  wifiHotspot: "WLAN-Hotspot",
  wifiHotspotDescription: "Surfen Sie während der Fahrt mit einem WLAN-Hotspot im Fahrzeug.",
  priorityPickup: "Priority-Abholung",
  priorityPickupDescription: "Der Fahrer wartet direkt am Gate und hilft mit Gepäckwagen – schnellster Weg zum Fahrzeug.",
  luggageAssistance: "Gepäckhilfe",
  luggageAssistanceDescription: "Der Fahrer leistet Hilfe für das Gepäck",
  meetAndGreet: "Meet & Greet",
  meetAndGreetDescription: "Der Fahrer empfängt Sie mit einem Namensschild und hilft beim Gepäck.",
  errorSavingData: "Fehler beim Speichern der Daten.",
  fillRequiredFields: "Füllen Sie bitte alle Pflichtfelder aus",
  fillAllRequiredFields: "Bitte füllen Sie alle Pflichtfelder aus",
  requiredField: "Pflichtfeld",
  invalidEmail: "Ungültige E-Mail-Adresse",
  pleaseSelect: "bitte wählen",
  title: "Titel",
  salutation: "Anrede",
  lastName: "Nachname",
  firstName: "Vorname",
  mobileNumber: "Mobilfunk-Nr.",
  emailAddress: "E-Mail Adresse",
  zipCode: "Postleitzahl",
  city: "Stadt",
  address: "Adresse",
  houseNumber: "Haus-Nr.",
  flightNumber: "Flugnummer",
  infoForDriver: "Informationen an Fahrer",
  personalDataTitle: "Persönliche Daten",
  personalDataDesc: "Daten zu Ihrer Person",
  contactTitle: "Kontakt",
  contactDesc: "Hinterlegen Sie hier Ihre Kontaktdaten, damit der Dienstleister Sie bei Fragen kontaktieren kann.",
  addressTitle: "Anschrift",
  addressDesc: "Bitte geben Sie Ihre vollständige Anschrift an, damit diese korrekt auf der Rechnung angegeben werden kann.",
  outboundFlightTitle: "Hinflugdaten",
  returnFlightTitle: "Rückflugdaten",
  flightDataDesc: "Bitte geben Sie Ihre vollständigen Flugdaten an, damit wir Ihren Transfer optimal planen können.",
  mr: "Herr",
  mrs: "Frau",
  diverse: "Divers",
  reviewAndPayTitle: "Angaben prüfen & Zahlung",
  choosePaymentMethod: "Zahlungsmethode wählen",
  comingSoon: "Bald verfügbar",
  cashLabel: "Barzahlung",
  cashDesc: "Zahlung direkt beim Fahrer – Buchung wird sofort bestätigt",
  cardOnTripLabel: "Kartenzahlung an Fahrer",
  cardOnTripDesc: "Bezahlung per Karte direkt vor Ort am Tag des Transfers",
  stripeLabel: "Kreditkarte / Debitkarte",
  stripeDesc: "Visa, Mastercard, Amex, Apple Pay, Google Pay – sofortige Bestätigung",
  customOfferLabel: "Angebot machen",
  customOfferDesc: "Eigenen Preis vorschlagen – Anbieter prüft und bestätigt",
  yourOfferLabel: "Ihr Preisvorschlag",
  offerHint: "⏳ Muss vom Anbieter bestätigt werden – Sie erhalten dann einen Zahlungslink per E-Mail.",
  offerInfoBanner: "Ihr Preisvorschlag wird an den Anbieter weitergeleitet. Dieser muss Ihr Angebot erst bestätigen. Nach der Bestätigung erhalten Sie einen individuellen Zahlungslink per E-Mail.",
  invoiceLabel: "Auf Rechnung",
  invoiceDesc: "Zahlung nach Erhalt der Rechnung",
  installmentLabel: "Ratenzahlung",
  installmentDesc: "In bequemen Raten bezahlen",
  couponTitle: "Gutscheincode",
  couponPlaceholder: "Code eingeben …",
  redeem: "Einlösen",
  couponInvalid: "Dieser Gutschein ist ungültig.",
  couponSuccess: "✓ Gutschein eingelöst!",
  bookingOverviewTitle: "Buchungsübersicht",
  reviewYourDataDesc: "Prüfen Sie Ihre Angaben",
  contactShortDesc: "Ihre Kontaktdaten",
  emailShort: "E-Mail",
  billingAddressDesc: "Rechnungsadresse",
  zipShort: "PLZ",
  outboundFlightDesc: "Flugdaten Hinreise",
  returnFlightDesc: "Flugdaten Rückreise",
  checkoutLabel: "Kasse",
  sumLabel: "Summe",
  regularPrice: "Regulärer Preis",
  vatNote: "* inkl. Mehrwertsteuer",
  shareLink: "Link teilen",
  scanQrCode: "QR-Code scannen",
  qrCodeAlt: "QR-Code dieser Seite",
  copyLink: "Link kopieren",
  linkCopied: "✓ Link kopiert!",
  agbTextBefore: "Ich habe die",
  agbLinkLabel: "Allgemeinen Geschäftsbedingungen",
  agbTextAfter: "gelesen und akzeptiere sie. *",
  newsletterOptinLabel: "Ja, ich möchte den Newsletter erhalten und keine Angebote verpassen.",
  agbRequiredHint: "* Bitte AGB akzeptieren, um fortzufahren.",
  sendingOffer: "Angebot wird gesendet …",
  redirecting: "Weiterleitung …",
  submitOffer: "Angebot absenden",
  payNow: "Jetzt bezahlen",
  bookingSubmitError: "Fehler beim Absenden der Buchung.",
  stripeSecureNote: "Sichere Zahlung – Powered by Stripe",
  cashNote: "Barzahlung direkt beim Fahrer",
  offerPendingNote: "Anbieter bestätigt & sendet Zahlungslink",
  completePaymentLabel: "Zahlung abschließen",
  footerCompanyDescription: "Wir haben unseren Service entwickelt, um Ihnen jederzeit und überall zuverlässige und qualitativ hochwertige Flughafentransferfahrten anzubieten – ganz ohne Probleme.",
  footerLinksTitle: "Links",
  aboutUs: "Über uns",
  bookTransfer: "Transfer Buchen",
  footerServiceTitle: "Service",
  vehicleFleet: "Fahrzeugflotte",
  faq: "FAQ",
  footerLegalTitle: "Rechtliches",
  privacyPolicy: "Datenschutz",
  termsAndConditions: "AGB",
  newsletterTitle: "Newsletter",
  newsletterDescription: "Aktuelle News und Updates direkt in Ihr Postfach.",
  emailPlaceholder: "Ihre E-Mail-Adresse",
  sending: "Wird gesendet…",
  subscribe: "Anmelden",
  newsletterEmailRequired: "Bitte geben Sie eine E-Mail-Adresse ein.",
  newsletterEmailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  newsletterSuccess: "Vielen Dank! Sie haben sich erfolgreich angemeldet.",
  newsletterError: "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  allRightsReserved: "Alle Rechte vorbehalten.",
  affiliateProgram: "Partnerprogramm",
  affiliateHeroTitle: "Werde Teil von",
  affiliateHeroAccent: "GoTransfer24.",
  affiliateHeroSub: "Empfiehl uns über Social Media, deine Webseite oder dein Unternehmen und verdiene an jeder erfolgreich vermittelten Fahrt mit.",
  becomeAffiliateCta: "Affiliate werden",
  whyPartnerWithUs: "Warum mit uns?",
  affiliateBenefitsTitleLine1: "Das bekommst du",
  affiliateBenefitsTitleLine2: "als Partner.",
  affiliateBenefit1: "Individuelle Provision auf jede vermittelte Buchung",
  affiliateBenefit2: "Eigener Tracking-Link zur einfachen Zuordnung",
  affiliateBenefit3: "Monatliche Auszahlung, volle Transparenz",
  affiliateBenefit4: "Kein Mindestumsatz, keine versteckten Kosten",
  affiliateCommissionTitle: "Wie wird die Provision berechnet?",
  affiliateCommissionExplanationText: "Die Provision wird individuell berechnet und richtet sich nach Reichweite, Zielgruppe und erwartetem Vermittlungsvolumen. Je nach Partnerprofil liegt sie üblicherweise zwischen 5 % und 15 % pro erfolgreich vermittelter Buchung. Nach deiner Bewerbung erhältst du ein persönliches Angebot mit deinem konkreten Satz.",
  affiliateCommissionDisclaimer: "Die Provision wird individuell berechnet und nach Prüfung deiner Bewerbung mitgeteilt.",
  affiliateStepsTitle: "In 3 Schritten zum Partner",
  affiliateStep1Title: "Bewerben",
  affiliateStep1Desc: "Formular ausfüllen und deine Reichweite angeben.",
  affiliateStep2Title: "Prüfung & Angebot",
  affiliateStep2Desc: "Wir prüfen dein Profil und schicken dir deinen individuellen Satz.",
  affiliateStep3Title: "Empfehlen & verdienen",
  affiliateStep3Desc: "Teile deinen Link und erhalte Provision auf jede Buchung.",
  affiliateFinalCtaTitle: "Bereit, mit uns zu wachsen?",
  affiliateMetaTitle: "Affiliate & Partnerprogramm",
  affiliateMetaDescription: "Werde Affiliate-Partner von GoTransfer24 und verdiene individuell berechnete Provision auf jede vermittelte Flughafentransfer-Buchung.",
  becomeAffiliateTitle: "Affiliate werden",
  becomeAffiliateIntro: "Fülle das Formular aus – wir melden uns mit einem individuellen Angebot bei dir.",
  firstNameRequiredError: "Bitte Vorname eingeben",
  lastNameRequiredError: "Bitte Nachname eingeben",
  emailRequiredError: "Bitte E-Mail-Adresse eingeben",
  emailInvalidError: "Bitte eine gültige E-Mail-Adresse eingeben",
  atLeastOneOfTheFollowing: "Mindestens eines der folgenden Felder ausfüllen:",
  atLeastOneSocialRequiredError: "Bitte mindestens einen Social-Media-Account oder ein Unternehmen angeben",
  companyOptional: "Unternehmen (optional)",
  companyNamePlaceholder: "Firmenname",
  submitApplication: "Bewerbung absenden",
  affiliateApplicationReceivedTitle: "Bewerbung erhalten!",
  affiliateApplicationReceivedText: "Danke für dein Interesse. Wir prüfen deine Angaben und melden uns mit deinem individuellen Provisionsangebot bei dir.",
  successTitleOffer: "Angebot eingegangen!",
  successTitleConfirmed: "Buchung bestätigt!",
  emailFallback: "Ihre E-Mail-Adresse",
  thankYouLabel: "Vielen Dank",
  offerSubtitlePart1: "! Ihr Preisvorschlag von",
  offerSubtitlePart2: "wurde an den Anbieter weitergeleitet. Nach der Prüfung erhalten Sie einen individuellen Zahlungslink an",
  cashSubtitlePart1: "! Ihre Buchung ist bestätigt. Bitte zahlen Sie den Betrag direkt beim Fahrer. Eine Bestätigung geht an",
  defaultSubtitlePart1: "! Ihre Zahlung wurde erfolgreich verarbeitet. Eine Buchungsbestätigung geht an",
  bookingNumberLabel: "Buchungsnummer",
  paymentTypeLabel: "Zahlungsart",
  creditCardLabel: "Kreditkarte",
  offerPaymentTypeLabel: "Angebot",
  statusLabel: "Status",
  statusPendingProviderCheck: "Ausstehend – Anbieter prüft",
  statusConfirmed: "Bestätigt",
  redirectingToOverviewPart1: "Sie werden in",
  secondsLabel: "Sekunde",
  redirectingToOverviewPart3: "zur Buchungsübersicht weitergeleitet …",
  redirectFailedText: "Automatische Weiterleitung fehlgeschlagen.",
  goToBookingOverview: "Zur Buchungsübersicht →",
  backToHomeLabel: "Zurück zur Startseite",
  cookieSettings: "Cookie-Einstellungen",
  logout: "Abmelden",
  language: "Sprache",
  driver: "Fahrer",
  ourtransfers: "Meine Fahrten",
  profiledescription: "Alle dir zugewiesenen Transferbuchungen",
  rows: "Datensätze",
  filtered: "gefiltert",
  pagingOf: "von",
  resetFilter: "zurücksetzen",
  selectedCount: "ausgewählt",
  clearSelection: "löschen",
  menuOpen: "Menü öffnen",
  menuClose: "Menü schließen",
  flightScheduled: "Planmäßig",
  flightActive: "Im Flug",
  flightLanded: "Gelandet",
  flightCancelled: "Annulliert",
  flightDiverted: "Umgeleitet",
  flightIncident: "Vorfall",
  flightRedirected: "Umgeleitet",
  flightPrefix: "Flug",
  flightLoading: "Flugdaten werden geladen …",
  flightNotFound: "Keine Flugdaten verfügbar für",
  flightCheckNote: "Bitte Flugnummer in der Notiz prüfen.",
  flightDeparture: "Abflug",
  flightArrival: "Ankunft",
  flightPlanned: "Geplant",
  flightDelay: "Verspätung",
  flightDelayDep: "Min Abflug",
  flightDelayArr: "Min Ankunft",
  flightBaggage: "Gepäckband",
  flightBaggageBand: "Band",
  flightAirline: "Airline",
  chatWithCustomer: "Chat mit Kunde",
  chatBooking: "Buchung",
  chatLoading: "Nachrichten werden geladen …",
  chatEmpty: "Noch keine Nachrichten. Schreibe dem Kunden eine Nachricht.",
  chatInputPlaceholder: "Nachricht schreiben …",
  chatDisabled: "Chat ist für vergangene/zukünftige Fahrten deaktiviert",
  chatOnlyToday: "Chat nur am Fahrttag verfügbar",
  chatClose: "Chat schließen",
  chatOpenLabel: "Chat öffnen",
  chatButtonLabel: "Chat",
  chatLoadError: "Fehler beim Laden der Nachrichten",
  chatSendFail: "Nachricht konnte nicht gesendet werden",
  chatSendError: "Fehler beim Senden der Nachricht",
  salutationMr: "Herr",
  salutationMrs: "Frau",
  tripReturn: "Hin- & Rückfahrt",
  tripOneway: "Einfache Fahrt",
  noTripsSearch: "Keine Ergebnisse für die aktuelle Suche",
  noTrips: "Keine Fahrten vorhanden",
  paymentLabel: "Zahlung",
  customerLabel: "Kunde",
  noteLabel: "Notiz",
  flightInfoLabel: "Fluginfo",
  yourSharePrefix: "Dein Anteil (Hinfahrt)",
  cancelBtn: "Stornieren",
  counterOfferBtn: "Gegenangebot",
  newBadge: "Neu",
  enrouteBtn: "Anfahrt",
  onboardBtn: "Abgeholt",
  noshowBtn: "Nicht Anwesend",
  completeBtn: "Abschließen",
  cancelledBadge: "Storniert",
  completedBadge: "Abgeschlossen",
  noshowDoneBadge: "Nicht Anwesend",
  complainedBadge: "Reklamiert",
  cancelTripTitle: "Fahrt stornieren?",
  cancelBookingPrefix: "Buchung",
  cancelNotifyText: "Die Fahrt wird storniert und der Kunde wird benachrichtigt.",
  fromLabel: "Von",
  toLabel: "Nach",
  abortBtn: "Abbrechen",
  confirmCancelBtn: "Ja, jetzt stornieren",
  tripCancelledToast: "wurde storniert",
  cancelErrorToast: "Fehler beim Stornieren",
  statusEnrouteLabel: "Anfahrt starten",
  statusEnrouteDesc: "Du startest jetzt die Anfahrt zum Kunden.",
  statusOnboardLabel: "Fahrgast abgeholt",
  statusOnboardDesc: "Du bestätigst, dass du den Fahrgast abgeholt hast.",
  statusCompletedLabel: "Fahrt abschließen",
  statusCompletedDesc: "Du markierst diese Fahrt als abgeschlossen.",
  confirmBtn: "Bestätigen",
  statusUpdateError: "Fehler beim Aktualisieren",
  statusEnrouteToast: "Anfahrt gestartet",
  statusOnboardToast: "Fahrgast abgeholt",
  statusCompletedToast: "Fahrt abgeschlossen",
  counterOfferTitle: "Gegenangebot machen",
  yourCounterOfferLabel: "Ihr Gegenvorschlag",
  counterOfferInvalid: "Bitte einen gültigen Betrag eingeben.",
  counterOfferSaveError: "Fehler beim Speichern. Bitte erneut versuchen.",
  counterOfferNotifyInfo: "Der Kunde erhält nach der Speicherung eine Benachrichtigung.",
  counterOfferSaving: "Wird gespeichert …",
  counterOfferSendBtn: "Gegenangebot senden",
  counterOfferSavedToast: "Gegenangebot für",
  counterOfferSavedToastSuffix: "gespeichert",
  vehicleDialogTitle: "Fahrzeug auswählen",
  vehicleLoading: "Fahrzeuge werden geladen …",
  vehicleLoadError: "Fahrzeuge konnten nicht geladen werden.",
  vehicleLoadErrorGeneric: "Fehler beim Laden der Fahrzeuge.",
  vehicleNoneAvailable: "Keine Fahrzeuge verfügbar.",
  vehicleStarting: "Wird gestartet …",
  vehicleStartBtn: "Anfahrt starten",
  vehiclePleaseChoose: "Bitte Fahrzeug wählen",
  vehicleSaveError: "Fehler beim Speichern.",
  vehicleStartError: "Fehler beim Starten der Anfahrt.",
  vehicleStartedToast: "Anfahrt gestartet",
  vehicleFallbackName: "Fahrzeug",
  noshowDialogTitle: "Nicht Anwesend melden",
  noshowInstructions: "Bitte mache ein Foto des Abholortes, auf dem dein Fahrzeug deutlich zu erkennen ist. Der Standort wird automatisch erfasst.",
  noshowMaxSizeSuffix: "Max.",
  currentLocationLabel: "Aktueller Standort",
  locationLoading: "Standort wird ermittelt …",
  locationReload: "Neu laden",
  locationRetry: "Erneut versuchen",
  locationUnavailable: "Standort nicht verfügbar",
  geoNotSupported: "Geolocation wird von diesem Gerät nicht unterstützt.",
  geoDenied: "Standort konnte nicht ermittelt werden. Bitte Zugriff erlauben.",
  photoOfPickupLabel: "Foto des Abholortes",
  photoTakeLabel: "Foto aufnehmen",
  photoHint: "Kamera öffnen · Fahrzeug muss sichtbar sein",
  photoChange: "Ändern",
  noshowNoteLabel: "Notiz",
  noshowNoteOptional: "(optional)",
  noshowNotePlaceholder: "z. B. Klingel nicht erreichbar, keine Antwort auf Anruf …",
  noshowMissingPhoto: "Bitte ein Foto des Abholortes aufnehmen.",
  noshowLocationPending: "Standort wird noch ermittelt. Bitte kurz warten.",
  noshowPhotoTooLargePrefix: "Das Foto ist zu groß",
  noshowPhotoTooLargeMax: "Maximum",
  noshowPhotoTooLargeHint: "Bitte ein kleineres Foto aufnehmen oder die Kameraqualität reduzieren.",
  noshowPhotoTooLargeHintShort: "Bitte ein kleineres Foto aufnehmen.",
  noshowGenericSaveError: "Fehler beim Speichern. Bitte erneut versuchen.",
  noshowSubmitError: "Fehler beim Übermitteln. Bitte erneut versuchen.",
  noshowSubmitting: "Wird übermittelt …",
  noshowConfirmBtn: "Nicht Anwesend bestätigen",
  noshowReportedToast: "Nicht anwesend gemeldet für",
  pickupLabel: "Abholort",
  current: "Aktuell",
  trips: "Fahrten",
  myData: "Meine Daten",
  documents: "Dokumente",
  other: "Sonstige",
  transfer_today: "Heute",
  transfer_tomorrow: "Morgen",
  transfer_all: "Alle Transfers",
  transfer_current: "Anstehend",
  transfer_finished: "Abgeschlossen",
  transfer_storno: "Storniert",
  transfer_noshow: "No Show",
  transfer_reklamiert: "Reklamiert",
  vehicle_class: "Meine Fahrzeuge",
  company: "Mein Unternehmen",
  cities: "Städte",
  wallet: "Wallet",
  receipts: "Quittungen",
  imprint: "Impressum",
  terms: "AGB",
  privacy: "Datenschutz",
  income: "Einnahmen",
  expenses: "Ausgaben",
  loading: "Lädt…",
  welcomeBack: "Willkommen zurück",
  dashboardErrorTitle: "Etwas ist schiefgelaufen",
  dashboardErrorText: "Daten konnten nicht geladen werden.",
  noWidgetsTitle: "Keine Widgets konfiguriert",
  noWidgetsText: "Es sind aktuell keine Übersichts-Kacheln verfügbar.",
  overview: "Übersicht",
  total: "Total",
  upcoming: "Anstehend",
  new: "Neu",
  tomorrow: "Morgen",
  thisWeek: "Diese Woche",
  count: "Anzahl",
  ofWhichNoShow: "Davon No Show",
  ofWhichComplained: "Davon reklamiert",
  transfer_total: "Gesamt",
transfer_done: "Abgeschlossen",
transfer_open: "Anstehend",
transfer_week: "Diese Woche",
transfer_storno_reklamiert: "Davon reklamiert",

newTrips: "Neue Fahrten",
notransferdatafound: "Keine Fahrten vorhanden.",
noTripsAvailable: "Keine Fahrten vorhanden",
returnTripOn: "Rückfahrt am",

generateInvoice: "Rechnung erzeugen",
details: "Details",
accept: "Annehmen",
changeDriver: "Fahrer wechseln",
assignDriver: "Fahrer zuweisen",
cancelList: "Stornieren",

counterOffer: "Gegenangebot",
acceptOffer: "Angebot annehmen",
waitingForCustomerResponse: "Warte auf Antwort des Kunden",
waitingForCustomerPayment: "Warte auf Zahlung des Kunden",
accepted: "Angenommen",

pleaseAssignDriver: "Bitte Fahrer zuweisen",
driverOnTheWay: "Fahrer unterwegs",

customerOnBoard: "Kunde an Bord",
completed: "Abgeschlossen",
noShow: "Nicht Anwesend",
complained: "Reklamiert",

acceptOfferQuestion: "Angebot annehmen?",
bookingPrefix: "Buchung",

confirmCustomerOffer: "Kundenangebot bestätigen",
customerOfferPaymentInfo: "Der Kunde wird per E-Mail benachrichtigt und zur Zahlung weitergeleitet. Nach der Zahlung wird die Buchung automatisch bestätigt.",

offerPrice: "Angebotspreis",

saving: "Wird gespeichert …",
yesAcceptOffer: "Ja, Angebot annehmen",

selectDriver: "Fahrer auswählen",
loadingDrivers: "Fahrer werden geladen …",

cancel: "Abbrechen",
confirmTrip: "Fahrt bestätigen",
pleaseSelectDriver: "Bitte Fahrer wählen",

cancelTripQuestion: "Fahrt stornieren?",
cancelIrreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
cancelNotifyCustomer: "Die Fahrt wird storniert und der Kunde wird benachrichtigt.",

from: "Von",
to: "Nach",

confirmCancel: "Ja, jetzt stornieren",

create: "Erstellen",

makeCounterOffer: "Gegenangebot machen",
originalPrice: "Ursprünglicher Preis",
customerOffer: "Kundenangebot",
yourCounterOffer: "Ihr Gegenvorschlag",
counterOfferNotify: "Der Kunde erhält nach der Speicherung eine Benachrichtigung.",
sendCounterOffer: "Gegenangebot senden",
// StepDialog (Neuer Datensatz)
newRecordTitle: "Neuen Datensatz erstellen",
enterValuePlaceholder: "eingeben...",
yes: "Ja",
no: "Nein",

// MatchDialog
selectMatch: "Auswahl treffen",

// ConfirmDialog
affectedRecords: "Betroffene Datensätze:",

// FilterDialog
applyFilterSubtitle: "Datensätze nach Kriterien filtern",
active: "Aktiviert",
inactive: "Deaktiviert",
reset: "Zurücksetzen",

// AdminEditDialog
editRecordTitle: "Datensatz bearbeiten",
bookingLabel: "Buchung",
noEditableFields: "Keine editierbaren Felder konfiguriert",
savingEllipsis: "Wird gespeichert …",
adminEditTooltip: "Datensatz bearbeiten (Admin)",

// Footer / Paging
searchLabel: "Suche:",
filterLabel: "Filter:",
clearLabel: "löschen",

// Trip-Type Fallbacks
tripTypeReturn: "Hin- & Rückfahrt",
tripTypeOneway: "Einfache Fahrt",

// Formatierung
driverFallbackPrefix: "Fahrer #",

// Toasts
toastOfferAccepted: "Angebot für #{id} angenommen – Kunde wird benachrichtigt",
toastInvoiceCreated: "Rechnung für #{id} wurde erstellt",
toastDriverChanged: "Fahrer gewechselt",
toastDriverConfirmed: "bestätigt",
toastTripUpdated: "Fahrt #{id} wurde {label}",
toastTripCancelled: "Fahrt #{id} wurde storniert",
toastCounterOfferSaved: "Gegenangebot für #{id} gespeichert",
toastRecordUpdated: "Datensatz #{id} wurde aktualisiert",

// Fehlermeldungen
errorAcceptOffer: "Fehler beim Annehmen des Angebots",
errorCreateInvoice: "Fehler beim Erstellen der Rechnung",
errorSaveTrip: "Fehler beim Speichern der Fahrt.",
errorChangeDriver: "Fehler beim Wechseln des Fahrers.",
errorConfirmTrip: "Fehler beim Bestätigen der Fahrt.",
errorCancelTrip: "Fehler beim Stornieren",
errorInvalidAmount: "Bitte einen gültigen Betrag eingeben.",
errorSaveRetry: "Fehler beim Speichern. Bitte erneut versuchen.",
errorLoadDriversFailed: "Fahrer konnten nicht geladen werden.",
errorLoadDrivers: "Fehler beim Laden der Fahrer.",
errorSaveDefault: "Fehler beim Speichern",
    close: "Schließen",
    discount: "Rabatt",
    couponAvailableNote: "Sichere dir jetzt deinen Rabatt-Gutschein für deine nächste Transferfahrt!",
    copied: "Kopiert!",
    clickToCopy: "Klicken zum Kopieren",
    appDownloadBannerText: "GoTransfer24 App",
appDownloadBannerCta:  "Laden",
planned: "Geplant",
aktive_stat: "Aktiv",
done: "Abgeschlossen",
cancelled: "Storniert",
en_route: "Fahrer unterwegs",
onboard: "Kunde an Board",
card: "Kartenzahlung",
cash: "Barzahlung",
cardOnTrip: "Kartenzahlung an Fahrer",
cardontrip: "Kartenzahlung an Fahrer",
thisweek: "Diese Woche",
unpaid: "Zahlung ausstehend",
paid: "Bezahlt",
paypalLabel: "PayPal",
paypalDesc: "Sicher bezahlen mit deinem PayPal-Konto",
paypalSecureNote: "Du wirst sicher zu PayPal weitergeleitet",
redirectingPaypal: "Weiterleitung zu PayPal …",
paypalCancelledNote: "Die PayPal-Zahlung wurde abgebrochen.",
paypalFailedNote: "Die PayPal-Zahlung konnte nicht abgeschlossen werden.",
paypal: "paypal",
actual: "Aktuell",
transfers: "Fahrten",
mydata: "Meine Daten",
others: "Sonstige",
vehicleclass: "Meine Fahrzeuge",
impressum: "Impressum",
agb: "AGB",
datenschutz: "Datenschutz",
booking: "Buchung",
transferTripLabel: "Transferfahrt",
outboundReturnTrip: "Hin- und Rückfahrt",
onewayTrip: "Einfache Fahrt",
pickupTag: "Abholung",
destinationTag: "Ziel",
dateLabel: "Datum",
departureLabel: "Abfahrt",
distanceLabel: "Strecke",
returnTripSection: "Rückfahrt",
customerSection: "Kunde",
phoneLabel: "Telefon",
passengersLabel: "Passagiere",
baggageLabel: "Gepäck",
emergencyContactLabel: "Notfallkontakt",
paymentSection: "Zahlung",
basePriceLabel: "Basispreis",
extrasLabel: "Extras",
customerOfferLabel: "Angebot des Kunden",
offerPriceLabel: "Angebotspreis",
counterOfferLabel: "Gegenangebot",
categoryLabel: "Kategorie",
paymentMethodLabel: "Zahlungsart",
pricePerKmLabel: "Preis/km",
receiptLabel: "Quittung",
createdLabel: "Erstellt",
notCreatedYetLabel: "Noch nicht erstellt",
originalPriceLabel: "Ursprünglicher Preis",
noCounterOfferYet: "Noch kein Gegenangebot abgegeben",
waitingCustomerResponse: "Warte auf Antwort des Kunden zum Gegenangebot",
priceAccepted: "Preis angenommen",
noShowReportSection: "No-Show Meldung",
reportedAtLabel: "Gemeldet am",
accuracyLabel: "Genauigkeit",
locationLabel: "Standort",
openInGoogleMaps: "Auf Google Maps öffnen",
driverNoteLabel: "Notiz des Fahrers",
driverNoticeLabel: "Fahrer-Hinweis",
driverPhotoLabel: "Foto vom Fahrer",
noShowPhotoAlt: "No-Show Beleg-Foto",
extrasSection: "Extras / Zusatzleistungen",
totalExtrasLabel: "Gesamt Extras",
notesSection: "Hinweise",
customerNoteLabel: "Kundennotiz",
shortNoteLabel: "Kurznotiz",
internalNoteLabel: "Interne Notiz",
ratingSection: "Bewertung",
bookingDetailsSection: "Buchungsdetails",
createdAtLabel: "Erstellt am",
updatedAtLabel: "Aktualisiert",
bookingSourceLabel: "Buchungsquelle",
tripTypeLabel: "Fahrttyp",
externalIdLabel: "Externe ID",
canceledAtLabel: "Storniert am",
cancelReasonLabel: "Stornogrund:",
saveButton: "Speichern",
paymentPendingLabel: "Zahlung ausstehend",
paidLabel: "Bezahlt",
paymentFailedLabel: "Fehlgeschlagen",
sourceWebsite: "Website",
sourceManual: "Manuell",
sourceApi: "API",
// Deutsch (de.js)
pleaseSelectImageFile: "Bitte eine Bilddatei auswählen.",
fileTooLargeError: "Datei zu groß (max. 10 MB).",
driverCreatedToast: "Fahrer wurde angelegt",
driverCreateErrorFallback: "Fehler beim Anlegen des Fahrers",
deleteDriverTitle: "Fahrer löschen",
deleteDriverConfirmPrefix: "Möchten Sie",
deleteDriverConfirmSuffix: "wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
driverDeletedToast: "Fahrer wurde gelöscht",
deleteErrorToast: "Fehler beim Löschen",
wasDeactivated: "wurde deaktiviert",
wasActivated: "wurde aktiviert",
statusUpdateErrorToast: "Fehler beim Aktualisieren des Status",
licenseExpired: "Abgelaufen",
licenseExpiresIn: "Läuft in",
daysAbbrev: "Tg. ab",
licenseValidUntil: "Gültig bis",
noDriversAvailable: "Keine Fahrer vorhanden.",
noResultsForFilters: "Keine Ergebnisse für die aktuellen Filter",
activeLabel: "Aktiv",
inactiveLabel: "Inaktiv",
detailsButton: "Details",
deactivateButton: "Deaktivieren",
activateButton: "Aktivieren",
deleteButton: "Löschen",
createDriverTitle: "Neuen Fahrer anlegen",
stepLabel: "Schritt",
ofLabel: "von",
yesLabel: "Ja",
noLabel: "Nein",
enterPlaceholderSuffix: "eingeben…",
enterPlaceholderSuffixNoDots: "eingeben...",
profilePhotoLabel: "Profilfoto",
optionalLabel: "optional",
previewAlt: "Vorschau",
changePhotoLabel: "Foto ändern",
uploadPhotoLabel: "Foto hochladen",
removePhotoLabel: "Foto entfernen",
photoOptionalHint: "Kein Pflichtfeld – das Foto kann auch später im Profil ergänzt werden.",
creatingLabel: "Wird erstellt…",
createButton: "Erstellen",
enabledLabel: "Aktiviert",
disabledLabel: "Deaktiviert",
applyFilterTitle: "Filter anwenden",
filterDriversDesc: "Fahrer nach Kriterien filtern",
noFilterableFields: "Keine filterbaren Felder verfügbar",
resetButton: "Zurücksetzen",
applyFilterButton: "Filter anwenden",
searchPlaceholder: "Durchsuchen",
filterButton: "Filter",
newDriverButton: "Neuer Fahrer",
ofLabelLower: "von",
filteredLabel: "gefiltert",
driversLabel: "Fahrer",
searchColonLabel: "Suche:",
resetLowerButton: "zurücksetzen",
filterColonLabel: "Filter:",
selectedLabel: "ausgewählt",
clearLowerButton: "löschen",
loadingAriaLabel: "Lädt…",
// Deutsch (de.js)
driverSavedToast: "Fahrer wurde gespeichert",
saveErrorToast: "Fehler beim Speichern",
imageProcessingError: "Fehler beim Verarbeiten des Bildes.",
savingLabel: "Speichert…",
photoCardTitle: "Foto",
photoSizeHint: "JPG/PNG, max. 10 MB · wird auf 300×600 px verkleinert",
dataCardTitle: "Daten",
// Deutsch (de.js)
licensePlateHint: "Format: 1–3 Buchstaben, 1–2 Buchstaben, 1–4 Ziffern – z. B. M AB 1234",
pricesLoadError: "Preise konnten nicht geladen werden.",
vehiclesLoadError: "Fahrzeuge konnten nicht geladen werden.",
pleaseSelectBrandError: "Bitte Marke wählen oder eingeben",
pleaseSelectModelError: "Bitte Modell wählen oder eingeben",
pleaseSelectColorError: "Bitte Farbe wählen oder eingeben",
pleaseEnterLicensePlateError: "Bitte Kennzeichen eingeben",
invalidFormatPrefix: "Ungültiges Format –",
vehicleAddedToast: "Fahrzeug wurde hinzugefügt",
vehicleAddErrorToast: "Fehler beim Hinzufügen des Fahrzeugs",
vehicleDeletedToast: "Fahrzeug wurde gelöscht",
vehicleDeleteErrorToast: "Fehler beim Löschen des Fahrzeugs",
vehicleActivatedToast: "Fahrzeug aktiviert",
vehicleDeactivatedToast: "Fahrzeug deaktiviert",
statusChangeErrorToast: "Fehler beim Ändern des Status",
pleaseSFillValidPricePrefix: "Bitte",
pleaseSFillValidPriceSuffix: "mit einem gültigen Preis ausfüllen",
pricesSavedToast: "Preise wurden gespeichert",
pricesSaveErrorToast: "Fehler beim Speichern der Preise",
vehicleCategoriesTitle: "Fahrzeugkategorien",
vehicleCategoriesDesc: "Staffelpreise und Fahrzeuge direkt pro Kategorie verwalten.",
vehiclesInThisClass: "Fahrzeuge in dieser Klasse",
pricesSectionLabel: "Preise",
tiersLabel: "Staffeln",
pricePerKmShort: "€ / km",
minPriceLabel: "Mindestpreis",
savePricesButton: "Preise speichern",
vehiclesSectionLabel: "Fahrzeuge",
loadingVehiclesLabel: "Lädt Fahrzeuge…",
noVehiclesInClassLabel: "Keine Fahrzeuge in dieser Klasse",
brandLabel: "Marke",
modelLabel: "Modell",
colorLabel: "Farbe",
licensePlateLabel: "Kennzeichen",
addVehicleTitle: "Fahrzeug hinzufügen",
selectBrandOption: "Marke wählen…",
otherOption: "Andere…",
enterBrandPlaceholder: "Marke eingeben",
selectModelOption: "Modell wählen…",
selectBrandFirstOption: "Erst Marke wählen",
enterModelPlaceholder: "Modell eingeben",
selectColorOption: "Farbe wählen…",
enterColorPlaceholder: "Farbe eingeben",
licensePlateExamplePlaceholder: "z. B. M AB 1234",
addVehicleButton: "Fahrzeug hinzufügen",
deleteVehicleModalTitle: "Fahrzeug löschen?",
thisVehicleLabel: "Dieses Fahrzeug",
willBeRemovedFromCategoryPrefix: "wird endgültig aus der Kategorie",
willBeRemovedFromCategorySuffix: "entfernt.",
deletingLabel: "Löscht…",
// Deutsch (de.js)
fileTooLargeMaxAlert: "Die Datei ist zu groß. Maximum: 10MB",
addressInputPlaceholder: "Adresse eingeben und aus der Liste auswählen...",
previewSuffix: "Vorschau",
uploadSuffix: "hochladen",
removeButton: "Entfernen",
photoUploadRecommendationHint: "Empfohlen: JPG/PNG, max. 10MB, wird automatisch auf 300x600px verkleinert",
addressRequiredFieldError: "Pflichtfeld – bitte Adresse aus der Liste auswählen",
noFieldGroupsDefined: "Keine Feldgruppen definiert",
fillAllRequiredAddressFieldsError: "Bitte fülle alle Pflichtfelder aus – wähle bei Adressfeldern einen Vorschlag aus der Liste aus.",
readonlyLabel: "schreibgeschützt",
// Deutsch (de.js)
selectAtLeastOneRecordError: "Bitte mindestens einen Datensatz auswählen.",
selectOnlyOneRecordToEditError: "Bitte nur einen Datensatz zum Bearbeiten auswählen.",
noRecordsSelectedError: "Keine Datensätze ausgewählt.",
actionExecutedSuccessSuffix: "erfolgreich ausgeführt",
noDataAvailableLabel: "Keine Daten vorhanden.",
noRecordsAvailableLabel: "Keine Datensätze vorhanden",
createNewRecordTitle: "Neuen Datensatz erstellen",
makeSelectionTitle: "Auswahl treffen",
affectedRecordsLabel: "Betroffene Datensätze:",
idsLabel: "IDs",
filterRecordsDesc: "Datensätze nach Kriterien filtern",
deselectAllLabel: "Alle abwählen",
selectAllLabel: "Alle auswählen",
clearSelectionLabel: "Auswahl löschen",
sortedByLabel: "Sortiert",
recordsLabel: "Datensätze",
filtersActiveLabel: "Filter aktiv",
// Deutsch (de.js)
addButtonLabel: "Hinzufügen",
// Deutsch (de.js)
periodAllLabel: "Alle",
periodTodayLabel: "Heute",
periodWeekLabel: "Woche",
periodMonthLabel: "Monat",
periodYearLabel: "Jahr",
transferLabel: "Überweisung",
cashShortLabel: "Bar",
cardShortLabel: "Karte",
canceledLabel: "Storniert",
balanceLoadError: "Saldo konnte nicht geladen werden.",
noWalletDataFound: "Keine Wallet-Daten gefunden.",
partnerAccountLabel: "Partner-Konto",
walletTitle: "Wallet",
currentBalanceLabel: "Aktueller Kontostand",
noPayableBalanceTitle: "Kein auszahlbares Guthaben",
payoutButton: "Auszahlen",
transactionsLabel: "Transaktionen",
searchBookingNumberPlaceholder: "Buchungsnummer durchsuchen",
noResultsForPrefix: "Keine Ergebnisse für",
noTransactionsInPeriod: "Keine Transaktionen in diesem Zeitraum.",
closeAriaLabel: "Schließen",
payoutRequestedTitle: "Auszahlung beantragt",
willBeTransferredSoonText: "werden in Kürze auf das hinterlegte Konto überwiesen.",
closeButton: "Schließen",
confirmPayoutTitle: "Auszahlung bestätigen",
amountTransferredToAccountText: "Der Betrag wird auf das folgende Konto überwiesen:",
accountHolderLabel: "Kontoinhaber",
ibanLabel: "IBAN",
bankLabel: "Bank",
payoutAmountLabel: "Auszahlungsbetrag",
payoutTriggerErrorText: "Auszahlung konnte nicht ausgelöst werden. Bitte erneut versuchen.",
requestingPayoutLabel: "Wird beantragt…",
payoutNowButton: "Jetzt auszahlen",
passengerCountTitle: "Personenanzahl",
// Deutsch
paymentCreditCardTitle: "Kreditkarte",
paymentCreditCardDescription: "Sichere Online-Zahlung direkt bei der Buchung.",
paymentPaypalTitle: "PayPal",
paymentPaypalDescription: "Bequem über Ihr PayPal-Konto zahlen – auch später oder in Raten möglich.",
paymentCashTitle: "Barzahlung",
paymentCashDescription: "Zahlen Sie den Festpreis bar direkt beim Fahrer.",
paymentCardOnTripTitle: "Karte beim Fahrer",
paymentCardOnTripDescription: "Kartenzahlung kontaktlos direkt im Fahrzeug.",
paymentCustomOfferTitle: "Eigener Preisvorschlag",
paymentCustomOfferDescription: "Schlagen Sie einen Preis vor, unser Partner bestätigt.",
paymentTagInstant: "Sofort bestätigt",
paymentTagSSL: "SSL-verschlüsselt",
paymentTagInstallments: "Ratenzahlung",
paymentTagPayLater: "Später bezahlen",
paymentTagNoPrepay: "Keine Vorabbuchung",
paymentTagContactless: "Kontaktlos",
paymentTagNegotiable: "Verhandelbar",
payHowItSuitsYou: "Zahlen, wie es",
payHowItSuitsYouAccent: "zu Ihnen passt.",
// Deutsch
roundTripSavingsNotice: "Sie sparen {percent}% bei Buchung von Hin- und Rückfahrt.",
selectDate: "Datum wählen",
clockSuffix: "Uhr",
removeReturnTrip: "Rückfahrt entfernen",
back: "Zurück",
date: "Datum",
time: "Uhrzeit",
apply: "Übernehmen",
pleaseChoose: "Bitte wählen",
cityAirport: "Stadt / Flughafen",
addReturnTrip: "Rückfahrt hinzufügen",
enterStartAddressError: "Bitte Startadresse eingeben",
selectAddressFromListError: "Bitte eine Adresse aus der Liste wählen",
enterDestinationAddressError: "Bitte Zieladresse eingeben",
dateRequiredError: "Datum erforderlich",
timeRequiredError: "Uhrzeit erforderlich",
departureTimeMinOneHourError: "Abfahrtszeit muss mindestens 1 Stunde in der Zukunft liegen",
returnDateRequiredError: "Rückfahrtdatum erforderlich",
returnTimeRequiredError: "Rückfahrtuhrzeit erforderlich",
returnTimeMinOneHourError: "Rückfahrtszeit muss mindestens 1 Stunde in der Zukunft liegen",
transferMode: "Transfer",
flightsMode: "Flüge",
slide: "Folie",
hotline: "Hotline",
email: "E-Mail",
services: "Zusatzleistungen",

//noch überstzen
setInitialPasswordButton: "Initialpasswort setzen",
setInitialPasswordTitle: "Initialpasswort festlegen",
setInitialPasswordDescription: "Bevor der Fahrer aktiviert wird, muss ein Initialpasswort für den ersten Login vergeben werden.",
resetInitialPasswordTitle: "Initialpasswort zurücksetzen",
resetInitialPasswordDescription: "Der Fahrer erhält ein neues Initialpasswort und muss beim nächsten Login ein eigenes Passwort festlegen.",
initialPasswordPlaceholder: "Passwort eingeben",
initialPasswordMinLengthError: "Das Passwort muss mindestens 8 Zeichen lang sein.",
confirmButton: "Bestätigen",
cancelButton: "Abbrechen",
driverActivatedToast: "Fahrer wurde aktiviert",
driverDeactivatedToast: "Fahrer wurde deaktiviert",
initialPasswordSetToast: "Initialpasswort wurde gesetzt",
driverLabel: "Fahrer",
tabNextTrip: "Nächste Fahrt",
tabToday: "Heute",
tabUpcoming: "Bevorstehend",
tabPast: "Vergangen",
tabNoshow: "NoShow",
noTripsInTab: "Keine Fahrten in dieser Ansicht.",
whatsappBtn: "WhatsApp",
callBtn: "Anrufen",
openInMapsBtn: "In Maps öffnen",
routeToPickupBtn: "Route zum Abholort",
routeToDestinationBtn: "Route zum Ziel",
paymentStatusLabel:   "Zahlungsstatus",
paymentStatusPaid:    "Bezahlt",
paymentStatusPending: "Ausstehend",
cancelReasonPlaceholder: "Grund für die Stornierung",
  waitingTime: "Wartezeit",
  waitingTimeDescription: "Der Fahrer wartet länger auf Sie – buchbar in 15-Minuten-Schritten.",
  pickupAdjust: "Abholzeit-Anpassung bei Flugverspätung",
  pickupAdjustDescription: "Bei Verspätung Ihres Fluges verschieben wir die Abholzeit automatisch – der Fahrer wartet dann auf Sie.",
  waitingFreeIncluded: "{min} Min kostenlos inklusive",
  waitingEachExtra: "je weitere {min} Min {price} €",
  flightRequiredForAdjust: "Für die gebuchte Abholzeit-Anpassung bitte die Flugnummer angeben (z. B. LH123).",
  sessionExpiredTitle: "Sitzung abgelaufen",
  sessionExpiredText: "Aus Sicherheitsgründen wurden Sie abgemeldet. Bitte melden Sie sich erneut an – Ihre Daten sind nicht verloren.",
  sessionExpiredButton: "Zur Anmeldung",
  flightHintTitle: "Passt Ihre Abholzeit zur Landung?",
  flightHintText: "Ihr Flug {flight} landet voraussichtlich um {landing} Uhr – Ihre gebuchte Abholzeit ({pickup} Uhr) liegt davor. Wählen Sie eine passende Abholzeit nach der Landung:",
  flightHintKeep: "Abholzeit {pickup} Uhr beibehalten",
  flightHintChanged: "Ihre Abholzeit wurde auf {time} Uhr angepasst.",
  flightHintReturnPrefix: "Rückfahrt",
  tabCancelled: "Storniert"
};

export default translations;
